import React from 'react'
import App from 'App/App'
import {Provider} from 'react-redux'
import store from 'redux/store'
import {ThemeProvider} from '@material-ui/core/styles'
import {MuiPickersUtilsProvider} from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import defaultTheme from 'style/theme/defaultTheme'

const AppProvider = () => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={defaultTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <App />
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </Provider>
  )
}

export default AppProvider
